/*
React nav component
*/

export default class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.style = {};

    // this.state = {

    // };
  }

  render() {
    var content = (
      <div className="navbar navbar-fixed-bottom">
        <div className="footer-bottom transition-all">

          {/* <div className="footer_button_div text-center">
            <div id="footer_button">
              <a>
                <i className="fa fa-bars fa-fw fa-3x"></i>
              </a>
            </div>
          </div> */}
          <div className="container-fluid">

            <hr/>
              <p className="pull-left" id="cpyRight">Copyright &copy; 2025 Carl Flint. All rights reserved.</p>
              <ul className="list-inline pull-right" id="socialMedia">
                <li>
                  <a href="https://github.com/cdflint" target="_blank">
                    <i className="fa fa-github fa-fw fa-3x"></i>
                  </a>
                </li>
                <li>
                  <a href="https://stackoverflow.com/users/8082326/carl-flint" target="_blank">
                    <i className="fa fa-stack-overflow fa-fw fa-3x"></i>
                  </a>
                </li>
                <li>
                <a href="https://www.linkedin.com/in/carl-flint-gisp-ba8087121/" target="_blank">
                    <i className="fa fa-linkedin fa-fw fa-3x"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      );

      return content;
    }
  };



// WEBPACK FOOTER //
// src/js/view/component/footer.jsx